export default __webpack_public_path__ + "static/media/about-us-banner-cn.2efaf0e3.webp";